import 'polyfills'
import React from 'react'
import ReactDom from 'react-dom'
import { Provider } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'

import 'redirects'
import { store, history } from 'store'
import EntryPoint from 'components/routes/EntryPoint'
import ShowMore from 'components/ShowMore'
import ShowMoreButton from 'components/ShowMoreButton'

require('isomorphic-fetch') // eslint-disable-line

ShowMore.showMoreButton = ShowMoreButton

const root = (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route
          path="/"
          exact
          render={() => <Redirect exact from="/" to={`/${window._winearoundDefaultLanguage || 'en'}`} />}
        />
        <Redirect exact from="/" to="/en" />
        <Route
          path="/:lang"
          render={(p) => <EntryPoint locale={p.match.params.lang} />}
        />
      </Switch>
    </ConnectedRouter>
  </Provider>
)

ReactDom.render(root, document.getElementById('root'))

if (module.hot) { // eslint-disable-line
  module.hot.accept() // eslint-disable-line
}

window.addEventListener('message', (message) => {
  if (message.data && message.data.type === 'WA_INIT_IFRAME') {
    window.__waRandomToken = message.data.random
    window.__waParentOrigin = message.origin
  }
})

window.setInterval(() => {
  if (window.__waParentOrigin) {
    const height = document.getElementById('root').clientHeight
    window.parent.postMessage({ height, waRandomToken: window.__waRandomToken, type: 'HEIGHT' }, window.__waParentOrigin)
  }
}, 100)
